exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".flex-1[data-v-2085ac2f]{flex:1}\n", ""]);

